var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: _vm.swiperRef, staticClass: "swiper-container" },
    [
      _c("div", { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.showNavigation
        ? [
            _c("div", { staticClass: "swiper-button-prev" }),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-button-next" }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }